class GoldstarNextTier extends HTMLElement {
  connectedCallback() {
    this.tiers = JSON.parse(this.dataset.tiers || '[]');
    this.template = this.dataset.template || '';
    const sectionId = this.dataset.sectionId;
    this.qtyInput = document.getElementById(`Quantity-${sectionId}`);
    if (!this.qtyInput || this.tiers.length === 0) return;

    this.qtyInput.addEventListener('input', this.update.bind(this));
    this.qtyInput.addEventListener('change', this.update.bind(this));
    this.update();
  }

  update() {
    const qty = parseInt(this.qtyInput.value, 10) || 0;
    const baseTier = this.tiers[0];
    const nextTier = this.tiers.find((tier) => tier.qty > qty);

    if (!nextTier || !baseTier) {
      this.hidden = true;
      return;
    }

    const discountPct = Math.round(
      ((baseTier.sale_price - nextTier.sale_price) / baseTier.sale_price) * 100
    );

    if (discountPct <= 0) {
      this.hidden = true;
      return;
    }

    const remaining = nextTier.qty - qty;
    this.textContent = this.template
      .replace('__QTY__', remaining)
      .replace('__PCT__', discountPct);
    this.hidden = false;
  }
}

customElements.define('goldstar-next-tier', GoldstarNextTier);
